export default __webpack_public_path__ + "static/media/Banner_download.302de8a7.svg";